<template>
  <div
    class="image"
    :class="[`image--size-${size}`, { 'image--loaded': loaded, 'image--loading': !loaded }]"
    :style="`--image-size: ${size}; --image-position: ${position}`"
  >
    <FontAwesomeIcon v-if="!loaded && !previewUrl" class="image__spinner" :icon="['fal', 'spinner-third']" spin />
    <img :src="src" :alt="alt" @load="onLoad" ref="image" :loading="lazy ? 'lazy' : 'eager'" />
    <span v-if="previewUrl" class="image__preview" :style="`--image-preview: ${previewUrl};`"></span>
  </div>
</template>

<script>
export default {
  props: {
    src: String,
    preview: String,
    alt: String,
    size: {
      type: String,
      default: 'cover',
    },
    lazy: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'center'
    }
  },
  data() {
    return {
      loaded: false,
    }
  },
  methods: {
    onLoad() {
      this.loaded = true
      this.$emit('loaded')
    },
  },
  computed: {
    previewUrl() {
      if(!this.preview) return ''
      if(this.preview.startsWith('url(')) return this.preview
      return `url(${this.preview})`
    }
  },
  mounted() {
    if (this.$refs.image.complete) this.onLoad()
  },
}
</script>

<style lang="scss">
.image {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  overflow: hidden;

  &--size-contain {
    padding: inherit;
  }

  &__spinner {
    color: css-alpha('primary', 0.5);
    position: relative;
    z-index: 1;
  }

  &__preview {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: var(--image-size);
    background-position: var(--image-position);
    background-image: var(--image-preview);
    background-repeat: no-repeat;

    padding: inherit;

    transition: all 150ms ease-out;

    .image--loaded & {
      opacity: 0;
    }
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: var(--image-size);
    object-position: var(--image-position);

    padding: inherit;

    transition: all 150ms ease-out;
    opacity: 0;
  }

  &--loaded img {
    opacity: 1;
  }
}
</style>
